import React from 'react';
import logomark from '@/assets/ingesta-full-logo.png';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-ingesta-blue-50 to-ingesta-teal-50 flex items-center justify-center p-4">
      <div className="w-full max-w-6xl flex items-center justify-center">
        <div className="hidden lg:flex lg:w-1/2 items-center justify-center p-8">
          <div className="text-center">
          <img src={logomark} alt="Ingesta" className="h-20 mx-auto" />
            <p className="text-lg text-slate-600 mb-8">
              Project Status Management Platform
            </p>
            <div className="space-y-4 text-left max-w-md">
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-ingesta-teal-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-slate-700">
                  Automated status synthesis from project documents
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-ingesta-teal-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-slate-700">
                  AI-powered insights and predictive analytics
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-ingesta-teal-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-slate-700">
                  Professional stakeholder dashboards
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-ingesta-teal-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-slate-700">
                  Multi-project workspace management
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full lg:w-1/2 flex flex-col items-center justify-center p-8">
          {/* Mobile logo - shown only on smaller screens */}
          <img src={logomark} alt="Ingesta" className="h-20 mb-2 lg:hidden" />
          {children}
        </div>
      </div>
    </div>
  );
}